module.exports = "HTML Element (Edit WYSIWYG Inline)\n\n<div class=\"checkbox\">\n    <label>\n        <input type=\"checkbox\" ng-model=\"element.data.contain\" /> Contain Width\n    </label>\n</div>\n\n\n<div style=\"position: absolute; top: 75px; left: 10px; right: 10px; bottom: 10px;\">\n<textarea ng-model=\"element.data.text\" style=\"width: 100%; height: 100%;\"></textarea>\n</div>\n\n<style>\n    .sgcontenteditor-editor-properties-pane {\n        overflow: hidden;\n    }\n</style>"


//////////////////
// WEBPACK FOOTER
// ./sgcontenteditor/elements/properties/html.html
// module id = 391
// module chunks = 0